// Section 12: the illness registry. IllnessId is derived from config.illnesses.
import type { Config } from '../../config';
import { checkRegistryKeys, type IllnessDef } from '../../core/registry';
import type { IllnessId } from '../../core/types';
import { fever } from './fever';
import { flux } from './flux';
import { injury } from './injury';
import { plague } from './plague';
import { wasting } from './wasting';

/** Build the illnesses registry for a config (content numbers come from the config, ADR-0008). */
export function buildIllnesses(config: Config) {
  const illnesses = Object.freeze({
    fever: fever(config),
    flux: flux(config),
    injury: injury(config),
    wasting: wasting(config),
    plague: plague(config),
  } satisfies Record<IllnessId, IllnessDef>);
  checkRegistryKeys('illnesses', illnesses);
  return illnesses;
}
